<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-divider>{{ $T('住宿预订') }}</el-divider>
      <div class="actions">
        <el-button type="primary" icon="el-icon-plus" @click="addBookingRow">{{ $T('添加房间') }}</el-button>
      </div>

      <el-table :data="bookingList" border stripe size="mini" style="width:100%" :empty-text="$T('暂无数据')">
        <el-table-column type="index" width="50" :label="$T('序号')"></el-table-column>
        <el-table-column :label="$T('预订酒店')" min-width="200">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.hotel_id"
              :placeholder="$T('请选择酒店')"
              clearable
              style="width:100%"
              @change="onHotelChange(scope.row)"
            >
              <el-option v-for="hotel in hotelOptions" :key="hotel.id" :label="hotel.title" :value="hotel.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$T('房型')" min-width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.room_type_id"
              :placeholder="$T('请选择房型')"
              clearable
              style="width:100%"
              @change="onRoomTypeChange(scope.row)"
            >
              <el-option v-for="roomType in getRoomTypeByHotel(scope.row.hotel_id)" :key="roomType.id" :label="roomType.name" :value="roomType.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$T('入住日期')" min-width="150">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.checkin_date"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:100%"
              :picker-options="checkinPickerOptions(scope.row)"
              @change="onCheckinChange(scope.row)"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column :label="$T('退房日期')" min-width="150">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.checkout_date"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:100%"
              :picker-options="checkoutPickerOptions(scope.row)"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column :label="$T('数量')" min-width="110">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.quantity" type="number" min="1" class="qty-input" @change="normalizeQuantity(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$T('价格')" min-width="120">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.price || 0).toFixed(2) }} USD</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('操作')" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" style="color:#f56c6c" @click="removeBookingRow(scope.$index)">{{ $T('删除') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="summary">
        <span>{{ $T('总数量') }}: {{ totalQuantity }}</span>
        <span>{{ $T('总价') }}: {{ totalPrice.toFixed(2) }} USD</span>
      </div>

      <div class="footer-button">
        <el-button type="primary" :loading="saveLoading" @click="onNextStep">{{ $T('下一步') }}</el-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.actions {
  margin-bottom: 12px;
}
.summary {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}
.footer-button {
  margin-top: 16px;
  text-align: center;
}
.form-content /deep/ .el-table .el-date-editor.el-input {
  width: 100%;
}
.qty-input {
  width: 100%;
}
</style>

<script>
const createBookingRow = () => ({
  hotel_id: null,
  room_type_id: null,
  checkin_date: '',
  checkout_date: '',
  quantity: 1,
  price: 0,
});

function normalizeBookingRowFromApi(row) {
  const r = Object.assign({}, row);
  const hid = r.hotel_id != null && r.hotel_id !== '' ? Number(r.hotel_id) : null;
  const rid = r.room_type_id != null && r.room_type_id !== '' ? Number(r.room_type_id) : null;
  r.hotel_id = hid && !Number.isNaN(hid) && hid > 0 ? hid : null;
  r.room_type_id = rid && !Number.isNaN(rid) && rid > 0 ? rid : null;
  r.quantity = r.quantity != null && r.quantity !== '' ? Number(r.quantity) : 1;
  r.price = r.price != null ? Number(r.price) : 0;
  r.checkin_date = r.checkin_date || '';
  r.checkout_date = r.checkout_date || '';
  if (r.checkin_date && r.checkout_date) {
    const inTs = new Date(r.checkin_date).setHours(0, 0, 0, 0);
    const outTs = new Date(r.checkout_date).setHours(0, 0, 0, 0);
    if (!Number.isNaN(inTs) && !Number.isNaN(outTs) && outTs <= inTs) {
      r.checkout_date = '';
    }
  }
  return r;
}

export default {
  name: 'SaiApplyFormStep3',
  data() {
    return {
      saveLoading: false,
      formData: {
        id: 0,
      },
      hotelOptions: [],
      roomTypeOptions: [],
      bookingList: [],
    };
  },
  computed: {
    totalQuantity() {
      return this.bookingList.reduce((total, row) => total + Number(row.quantity || 0), 0);
    },
    totalPrice() {
      return this.bookingList.reduce((total, row) => total + Number(row.quantity || 0) * Number(this.getDays(row) || 1) * Number(row.price || 0), 0);
    },
  },
  mounted() {
    this.formData.id = this.$route.query.id;
    document.title = this.$T('住宿预订');
    if (this.formData.id) {
      this.fetch();
    }
  },
  methods: {
    /** 当天 0 点时间戳，用于日历禁选比较 */
    startOfDayTs(dateVal) {
      if (!dateVal) {
        return null;
      }
      const d = new Date(dateVal);
      if (Number.isNaN(d.getTime())) {
        return null;
      }
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    },
    checkinPickerOptions(row) {
      const self = this;
      return {
        disabledDate(time) {
          if (!row.checkout_date) {
            return false;
          }
          const end = self.startOfDayTs(row.checkout_date);
          if (end == null) {
            return false;
          }
          const t = new Date(time);
          t.setHours(0, 0, 0, 0);
          return t.getTime() >= end;
        },
      };
    },
    checkoutPickerOptions(row) {
      const self = this;
      return {
        disabledDate(time) {
          if (!row.checkin_date) {
            return false;
          }
          const start = self.startOfDayTs(row.checkin_date);
          if (start == null) {
            return false;
          }
          const t = new Date(time);
          t.setHours(0, 0, 0, 0);
          return t.getTime() <= start;
        },
      };
    },
    onCheckinChange(row) {
      if (!row.checkin_date || !row.checkout_date) {
        return;
      }
      const inTs = this.startOfDayTs(row.checkin_date);
      const outTs = this.startOfDayTs(row.checkout_date);
      if (inTs == null || outTs == null) {
        return;
      }
      if (outTs <= inTs) {
        row.checkout_date = '';
      }
    },
    fetch() {
      this.$api.post('/api/isai/step3detail', { id: this.formData.id }, (res) => {
        const data = res.data || {};
        this.hotelOptions = data.hotel_options || [];
        this.roomTypeOptions = data.room_type_options || [];
        const detailList = data.room_booking_list || [];
        if (detailList.length > 0) {
          this.bookingList = detailList.map((row) => normalizeBookingRowFromApi(row));
        } else {
          this.bookingList = [createBookingRow()];
        }
      }, (res) => {
        this.$message.error(res.msg || this.$T('加载失败'));
      });
    },
    getRoomTypeByHotel(hotelId) {
      if (hotelId == null || hotelId === '') {
        return [];
      }
      return this.roomTypeOptions.filter((item) => Number(item.hotel_id) === Number(hotelId));
    },
    onHotelChange(row) {
      row.room_type_id = null;
      row.price = 0;
    },
    onRoomTypeChange(row) {
      const selected = this.roomTypeOptions.find((item) => Number(item.id) === Number(row.room_type_id));
      row.price = selected ? Number(selected.price || 0) : 0;
    },
    getDays(row) {
      if (!row.checkin_date || !row.checkout_date) {
        return Number(row.days || 1);
      }
      const start = new Date(row.checkin_date).getTime();
      const end = new Date(row.checkout_date).getTime();
      if (!start || !end || end <= start) {
        return 1;
      }
      const days = Math.ceil((end - start) / (24 * 3600 * 1000));
      return days > 0 ? days : 1;
    },
    normalizeQuantity(row) {
      const value = parseInt(row.quantity, 10);
      if (!value || value < 1) {
        row.quantity = 1;
        return;
      }
      if (value > 200) {
        row.quantity = 200;
        return;
      }
      row.quantity = value;
    },
    addBookingRow() {
      this.bookingList.push(createBookingRow());
    },
    removeBookingRow(index) {
      this.bookingList.splice(index, 1);
      if (this.bookingList.length === 0) {
        this.bookingList.push(createBookingRow());
      }
    },
    onNextStep() {
      for (let i = 0; i < this.bookingList.length; i++) {
        const row = this.bookingList[i];
        const n = i + 1;
        if (row.hotel_id == null || row.hotel_id === '' || Number(row.hotel_id) <= 0) {
          this.$message.warning(this.$T('请选择酒店') + ' (' + n + ')');
          return;
        }
        if (row.room_type_id == null || row.room_type_id === '' || Number(row.room_type_id) <= 0) {
          this.$message.warning(this.$T('请选择房型') + ' (' + n + ')');
          return;
        }
        if (!row.checkin_date || !row.checkout_date) {
          this.$message.warning(this.$T('请选择入住退房日期') + ' (' + n + ')');
          return;
        }
        if (new Date(row.checkout_date).getTime() <= new Date(row.checkin_date).getTime()) {
          this.$message.warning(this.$T('退房须晚于入住') + ' (' + n + ')');
          return;
        }
      }
      this.saveLoading = true;
      const payload = this.bookingList.map((row) => ({
        hotel_id: Number(row.hotel_id),
        room_type_id: Number(row.room_type_id),
        checkin_date: row.checkin_date,
        checkout_date: row.checkout_date,
        quantity: Number(row.quantity || 0),
        days: this.getDays(row),
      }));
      this.$api.post('/api/isai/roomSave', {
        baoming_id: this.formData.id,
        booking_list: JSON.stringify(payload),
      }, () => {
        this.saveLoading = false;
        this.$message.success(this.$T('保存成功'));
        rbLink({
          name: 'ISaiApplyDetail',
          query: {
            id: this.formData.id,
          },
        }, 'back');
      }, (res) => {
        this.saveLoading = false;
        this.$message.error(res.msg || this.$T('保存失败'));
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep3.vue?a34c59be